/**
 * Règles de la page d'invitation, celle que l'employé ouvre par son lien.
 *
 * Elles se vérifient seules : ce que la page reproche à une saisie avant
 * d'appeler le serveur, et où elle mène une fois l'accès ouvert.
 */

/** Longueur minimale du mot de passe, la même que le serveur exige. */
export const LONGUEUR_MOT_DE_PASSE = 10;

/**
 * Adresse où l'employé continue une fois son accès ouvert.
 *
 * <p>Le contrat à signer l'attend dans son espace : l'application s'ouvre sur
 * l'onglet Contrat quand c'est le cas.
 *
 * @param {boolean} contratASigner vrai si le contrat attend sa signature
 * @returns {string} l'adresse de l'application
 */
export function adresseApresAcceptation(contratASigner) {
  return contratASigner ? '/?onglet=contrat' : '/';
}

/** Rôles du bureau : ils entrent par adresse et mot de passe, jamais par un code. */
export const ROLES_DU_BUREAU = ['PATRON', 'TECHNICIEN', 'SECRETAIRE', 'COMPTABLE'];

/**
 * Vrai pour un rôle du bureau.
 *
 * @param {string} role rôle de l'invitation
 * @returns {boolean} vrai s'il entre par adresse et mot de passe
 */
export function estDuBureau(role) {
  return ROLES_DU_BUREAU.includes(role);
}

/**
 * Vérifie ce que l'employé a saisi, avant d'appeler le serveur.
 *
 * <p>Le bureau ne choisit pas de code : son adresse et son mot de passe sont
 * exigés, le serveur refusant de lui ouvrir le bureau par quatre chiffres.
 *
 * @param {{pin: string, pin2: string, parEmail: boolean, email: string, motDePasse: string, bureau?: boolean}} saisie
 * @returns {string} le reproche, ou une chaîne vide si tout va
 */
export function reprocheSaisie({ pin, pin2, parEmail, email, motDePasse, bureau = false }) {
  if (!bureau) {
    if (!/^\d{4}$/.test(pin || '')) return 'Choisis un code à quatre chiffres.';
    if (pin !== pin2) return 'Les deux codes ne sont pas identiques.';
  }
  if (parEmail || bureau) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim())) {
      return 'Indique une adresse e-mail valable.';
    }
    if ((motDePasse || '').length < LONGUEUR_MOT_DE_PASSE) {
      return `Le mot de passe doit comporter au moins ${LONGUEUR_MOT_DE_PASSE} caractères.`;
    }
  }
  return '';
}
